import { Api, decryptApiResponse} from "../../../../config/Api";
import { statusAndResponse } from "../../../../util/requestHandler";

export const getAirCallMessages = async (queryParams) => {
  return statusAndResponse(
    Api.get(`/api/sms/v1/aircall/messages?${queryParams}`),
      decryptApiResponse,
  );
};
